var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInjuryFootLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 59,
    viewBox: "0 0 24 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.098 1v12.419c1.997 2.536 1.997 4.933 0 7.19-1.036 3.732.036 8.598 3.214 14.6 4.768 9 3.505 16.584-5.424 21.635C5.959 61.895.274 52.747 1.075 47.751c.8-4.995 3.448-19.95 1.724-27.141-1.15-4.794-.86-7.357.87-7.69C4.866 11.895 5.465 7.922 5.465 1H17.098z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryFootLeft);
export default __webpack_public_path__ + "static/media/injury-foot-left.0bfd01aeb2bb1b38ba086eae320725d5.svg";
export { ForwardRef as ReactComponent };